import StatusCircle from '../../ui-components/StatusCircle'

const StatusCell = () => {
  return ({ is_published }) => {
    return (
      <div className='articles-overview__status'>
        <StatusCircle variant={is_published ? 'published' : 'draft'} />
        { is_published ? 'Published' : 'Draft' }
      </div>
    )
  }
}

export default StatusCell
